import { B2CPolicy, IEnvironmentVariables } from './IEnvironment';

export const b2cPolicies: B2CPolicy = {
  names: {
    signUpSignIn: 'B2C_1A_Signup_Signin',
    forgotPassword: 'B2C_1A_PasswordReset'
  },
  authorityBaseUrl: 'https://mncportalprod.b2clogin.com/tfp/mncportalprod.onmicrosoft.com'
};

export const environment: IEnvironmentVariables = {
  commonDomainEmailNoteReleaseDate: '2025-09-01T00:00:00Z',
  b2cPolicies: b2cPolicies,
  production: true,
  buildNumber: '_BUILDNUMBER_',
  version: '_VERSION_',
  baseUrl: 'https://usermgmt.portalct.mynexuscare.com/',
  apiUrl: 'https://api-homehealth.portalct.mynexuscare.com',
  platformApiUrl: 'https://api-platform.portalct.mynexuscare.com',
  registryUrl: `https://api-platform.portalct.mynexuscare.com/api/app-registry`,
  authConfig: {
    config: {
      auth: {
        clientId: '121f5e9f-2ad5-453b-b06b-dd3546787749',
        postLogoutRedirectUri: 'https://usermgmt.portalct.mynexuscare.com/login',
        redirectUri: 'https://usermgmt.portalct.mynexuscare.com/login',
        knownAuthorities: ['mncportalprod.b2clogin.com'],
        authority: `${b2cPolicies.authorityBaseUrl}/${b2cPolicies.names.signUpSignIn}`,
        navigateToLoginRequestUrl: false,
      },
    },
    angularConfig: {
      consentScopes: [
        'https://mncportalprod.onmicrosoft.com/api/api.Write',
        'https://mncportalprod.onmicrosoft.com/api/api.Read',
        'https://mncportalprod.onmicrosoft.com/api/user_impersonation',
      ],
      protectedResourceMap: [
        [
          'https://api-homehealth.portalct.mynexuscare.com/',
          [
            'https://mncportalprod.onmicrosoft.com/api/api.Write',
            'https://mncportalprod.onmicrosoft.com/api/api.Read',
            'https://mncportalprod.onmicrosoft.com/api/user_impersonation',
          ]
        ],
        [
          'https://api-platform.portalct.mynexuscare.com/',
          [
            'https://mncportalprod.onmicrosoft.com/api/api.Write',
            'https://mncportalprod.onmicrosoft.com/api/api.Read',
            'https://mncportalprod.onmicrosoft.com/api/user_impersonation',
          ]
        ]
      ]
    }
  }
};
